export default __webpack_public_path__ + "static/silverSCover-571ae57f8cfbaca0213f8c771390fcba.png";